import React from 'react';

const IconDiamond = () => {

    return(
        <svg 
            version="1.1" 
            xmlns="http://www.w3.org/2000/svg" 
            xlink="http://www.w3.org/1999/xlink" 
            viewBox="0 0 220 220"
        >
            <g 
                fill="rgba(255, 255, 255, 0)"
                fill-rule="nonzero" 
                stroke="none" 
                stroke-width="1" 
                stroke-linecap="butt" 
                stroke-linejoin="miter" 
                stroke-miterlimit="10" 
                stroke-dasharray="" 
                stroke-dashoffset="0" 
                font-family="none" 
                font-weight="none" 
                font-size="none" 
                text-anchor="none" 
                style={{mixBlendMode: 'normal'}}
            >
                <path 
                    d="M0,220v-220h220v220z" 
                    fill="rgba(255, 255, 255, 0)"
                >
                </path>

                <g>
                    <path 
                        d="M147.18385,9.27624l20.09239,56.96802l-81.01972,96.13293l-81.10425,-96.39938l20.17692,-56.70156z" 
                        fill="rgba(255, 255, 255, 0)"
                    ></path>

                    <path 
                        d="M25.32921,9.27624l34.08577,56.70156l31.21763,-56.70156l26.75372,56.70156l29.79753,-56.70156z" 
                        fill="rgba(255, 255, 255, 0)"
                    >
                    </path>

                    <path 
                        d="M59.41497,65.9778l26.84156,96.39938l31.12979,-96.39938z" 
                        fill="rgba(255, 255, 255, 0)"
                    ></path>
                    
                    <path 
                        id='diamond'
                        d="M171.74825,63.54481l-19.69915,-55.79636c-0.71887,-2.0346 -2.70312,-3.38377 -4.86562,-3.38377h-121.85428c-2.15551,0 -4.13682,1.34219 -4.86047,3.37054l-20.17692,56.6729c-0.60384,1.70052 -0.25616,3.64544 0.91145,5.02622l81.10388,96.3924c2.02651,2.41131 5.86821,2.41168 7.89546,0l81.01972,-96.13477c0.86184,-1.02208 0.96033,-5.39227 0.52592,-6.14716zM26.531,21.42209l23.76944,39.54089h-37.84zM68.13846,60.96297l22.13985,-40.21309l18.97403,40.21309zM110.30235,71.25357l-23.68014,73.33044l-20.41838,-73.33044zM55.49499,71.25357l19.42534,69.76474l-58.695,-69.76474zM121.14239,71.25357h35.27286l-57.18338,67.84996zM125.9198,60.96297l20.33091,-38.6875l13.64497,38.6875zM138.65001,14.65528l-21.01524,39.98963l-18.86818,-39.98963zM81.90875,14.65528l-22.69077,41.21311l-24.77425,-41.21311z" 
                        fill="rgba(255, 255, 255, 0)"
                    ></path>
                </g>
            </g>
        </svg>
    )
}

export default IconDiamond;
